import React from 'react';
import { Card, CardActions, CardContent, Typography } from '@mui/material';
import { infoCardStyles } from './info-card-helper';

interface InfoCardProps {
    title: string;
    description?: string;
    action?: React.ReactNode;
    children?: React.ReactNode;
}

export const InfoCard = (props: InfoCardProps): React.JSX.Element => {
    return (
        <Card elevation={0} sx={infoCardStyles.card}>
            <CardContent sx={infoCardStyles.cardContent}>
                <Typography
                    variant='h4'
                    color='text.secondary'
                    sx={infoCardStyles.title}
                >
                    {props.title}
                </Typography>

                {props.description && (
                    <Typography variant='body1' sx={infoCardStyles.description}>
                        {props.description}
                    </Typography>
                )}
                {props.children}
            </CardContent>
            {props.action && (
                <CardActions sx={infoCardStyles.cardActions}>
                    {props.action}
                </CardActions>
            )}
        </Card>
    );
};
